import React, { FC, useId, useMemo, useState } from 'react';
import { useAppSelector } from 'hooks';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Box } from '@mui/material';
import { ALL_FACILITIES_STATISTIC_VALUE } from './libs/constants/constants';

type Properties = {
  onFacilityChange: (facilityId: string) => void;
};

const FacilitySelector: FC<Properties> = ({ onFacilityChange }) => {
  const facilities = useAppSelector((state) => state.facility.facilities);
  const [facilityName, setFacilityName] = useState('');
  const id = useId();

  const facilitiesData = useMemo(() => {
    return facilities.map(({ name, id }) => ({ name, id }));
  }, [facilities]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    if (event.target.value === ALL_FACILITIES_STATISTIC_VALUE) {
      handleChooseAllFacilityStatistic();

      return;
    }
    setFacilityName(event.target.value);
    const facility = facilitiesData.find((facility) => facility.name === event.target.value);
    onFacilityChange(facility?.id ?? '');
  };

  const handleChooseAllFacilityStatistic = () => {
    setFacilityName(ALL_FACILITIES_STATISTIC_VALUE);
    onFacilityChange('');
  };

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel htmlFor={id}>Facility</InputLabel>
        <Select value={facilityName} onChange={handleChange} label='Facility' displayEmpty id={id}>
          <MenuItem value={ALL_FACILITIES_STATISTIC_VALUE}>{ALL_FACILITIES_STATISTIC_VALUE}</MenuItem>
          {facilitiesData.map(({ name, id }) => (
            <MenuItem value={name} key={id}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export { FacilitySelector };
